export default {
    page_title: 'Borrowings',
    page_description: 'Manage resource borrowings',
    myBorrowings: 'My Borrowings and Reservations',
    allBorrowings: 'All Borrowings and Reservations',
    details: 'Details',
    add_borrowing: 'Add Borrowing',
    edit_borrowing: 'Edit Borrowing',
    editTitle: 'Edit Borrowing',
    resource: 'Resource',
    user: 'User',
    borrower: 'Borrower',
    borrowed_date: 'Borrowed Date',
    due_date: 'Due Date',
    expected_return: 'Expected Return',
    expected_return_date: 'Expected Return Date',
    expected_return_date_placeholder: 'Select return date and time',
    return_date: 'Return Date',
    returned_at: 'Returned At',
    returned_at_placeholder: 'Select return date and time',
    return_notes: 'Return Notes',
    return_notes_placeholder: 'Enter any notes about the return...',
    reservation_notes: 'Reservation Notes',
    return_preview: 'Return expected:',
    is_returned: 'Returned',
    status: 'Status',
    notes: 'Notes',
    notes_placeholder: 'Enter any notes about this borrowing...',
    add: 'Add',
    edit: 'Edit',
    borrow: 'Borrow',
    return: 'Mark as Returned',
    return_item: 'Return Item',
    added_successfully: 'Borrowing added successfully',
    updated_successfully: 'Borrowing updated successfully',
    returned_successfully: 'Item returned successfully',
    invalid_date_range: 'Due date must be after borrowed date',
    active: 'Active',
    returned: 'Returned',
    overdue: 'Overdue',
    forMyself: 'For myself',
    borrowFor: 'Borrow for this user',
    unknown_resource: 'Unknown Resource',
    unknown_user: 'Unknown User',
    expected_return_date_required: 'Expected return date is required',
    quickDate: {
        title: 'Select Duration',
        hours: 'Hours',
        days: 'Days',
        '1h': '1h',
        '2h': '2h',
        '3h': '3h',
        '4h': '4h',
        '6h': '6h',
        '8h': '8h',
        '12h': '12h',
        '1d': '1d',
        '2d': '2d',
        '3d': '3d',
        '4d': '4d',
        '5d': '5d',
        '6d': '6d',
        '7d': '7d',
        tooltip: 'Quick select: {{label}}'
    },
    no_date_selected: 'No return date selected',
    manual_date_selection: 'Manual date selection',
    click_to_open_calendar: '(click to open calendar)',

    // Borrowing Return specific translations
    borrowingReturn: {
        returnBorrowing: 'Return Borrowing',
        subtitle: 'Return {{resourceName}}',
        loading: 'Loading...',
        notFound: 'Borrowing not found',
        fetchError: 'Error fetching borrowing',
        returnError: 'Error returning borrowing'
    },

    // Borrowing Borrow specific translations
    borrowingBorrow: {
        borrowResource: 'Borrow Resource',
        subtitle: 'Borrow {{resourceName}}',
        loading: 'Loading...',
        notFound: 'Reservation not found',
        fetchError: 'Error fetching reservation',
        borrowError: 'Error borrowing resource'
    },
    calendar: {
        tabLabel: 'Calendar',
        title: 'Borrowing Calendar',
        description: 'View and open borrowings in the calendar.'
    },

    // Participation
    participation: {
        title: 'Participation',
        myStatus: 'My Participation',
        yes: 'Participating',
        no: 'Not Participating',
        maybe: 'Maybe',
        participants: 'Participants',
        participantsCount: '{{count}} participant(s)',
        noParticipants: 'No participants yet',
        statusUpdated: 'Participation status updated',
        statusUpdateFailed: 'Failed to update participation status',
        participantsYes: 'Confirmed',
        participantsMaybe: 'Uncertain',
        participantsNo: 'Not participating'
    },

    // Reservation Validation
    validation: {
        title: 'Reservation Validation',
        currentStatus: 'Validation Status',
        validatedBy: 'Validated By',
        validatedAt: 'Validated At',
        notes: 'Validation Notes',
        notesLabel: 'Notes (optional)',
        notesPlaceholder: 'Add a note for the requester...',
        approve: 'Approve Reservation',
        reject: 'Reject Reservation',
        validated: 'Reservation validated successfully',
        rejected: 'Reservation rejected',
        error: 'Failed to validate reservation',
        pendingValidation: 'This reservation is awaiting validation from a manager.',
        validationRejected: 'This reservation has been rejected.',
        cannotBorrow: 'This resource requires reservation validation. Please make a reservation first.',
        tabLabel: 'Validations',
        noPending: 'No pending validations',
        noPendingDescription: 'All reservations have been processed.'
    }
};
